'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	hierarchicalNumbers = require('./sequence-by-level-label-generator');
module.exports = function ArgumentMappingModel(mapModel, mapThemeModel, collaborationModel, mapEditorModel) {
	if (!mapModel || !mapThemeModel || !collaborationModel || !mapEditorModel) {
		throw new Error('invalid-args');
	}
	let labelGeneratorSet, wasActive = false, oldTheme;

	const self = observable(this),
		mapModelAddSubIdea = mapModel.addSubIdea,
		isGroup = function (idea) {
			return idea && idea.attr && idea.attr.group;
		},
		isIdeaAStickyNote = (idea) => {
			return idea && idea.attr && idea.attr.styleNames && Array.isArray(idea.attr.styleNames) && idea.attr.styleNames.includes('sticky_note');
		},
		isNodeIdClaim = function (nodeId) {
			const idea = collaborationModel.getActiveContent().findSubIdeaById(nodeId);
			return idea && !isGroup(idea) && !isIdeaAStickyNote(idea);
		},
		addStickyNote = (source, parentId, initialTitle) =>  {
			mapModelAddSubIdea(source, parentId, initialTitle, {styleNames: ['sticky_note']});
		},
		addSubIdea = function (source, parentId, initialTitle) {
			const ideaId = parentId || mapModel.getSelectedNodeId(),
				content = collaborationModel.getActiveContent(),
				idea = content.findSubIdeaById(ideaId);
			if (isIdeaAStickyNote(idea)) {
				addStickyNote(source, parentId, initialTitle);
			} else if (isGroup(idea)) {
				mapModelAddSubIdea(source, parentId, initialTitle);
			} else {
				mapModel.addGroupSubidea(source, {group: 'supporting', parentId: ideaId, initialTitle: initialTitle});
			}
		},
		mapModelDropNode = mapModel.dropNode,
		dropNode = function (nodeId, dropTargetId, shiftKey) {
			const content = collaborationModel.getActiveContent(),
				parentIdea = content.findParent(nodeId);

			if ((dropTargetId !== nodeId) &&
				(dropTargetId !== parentIdea.id) &&
				isNodeIdClaim(dropTargetId) &&
				isNodeIdClaim(nodeId)
			) {
				return content.batch(function () {
					return content.changeParent(nodeId, dropTargetId) &&
						content.insertIntermediateMultiple([nodeId], { title: 'group', attr: {group: 'supporting', contentLocked: true}});
				});
			} else {
				mapModelDropNode(nodeId, dropTargetId, shiftKey);
			}
		},
		mapModelPaste = mapModel.paste,
		paste = function (source) {
			const pastingIntoClaim = isNodeIdClaim(mapModel.getSelectedNodeId()),
				result = mapModelPaste(source);
			if (pastingIntoClaim && result && Array.isArray(result)) {
				collaborationModel.getActiveContent().insertIntermediateMultiple(result.filter(isNodeIdClaim), { title: 'group', attr: {group: 'supporting', contentLocked: true}});
			}
			return result;
		},
		isArgumentMappingTheme = function (idea) {
			return (idea && idea.attr && /^argMapping/.test(idea.attr.theme));
		},
		isMappingActive = function (idea) {
			return !!isArgumentMappingTheme(idea);
		},
		mapModelOverridesWhenActive = function () {
			if (isMappingActive(collaborationModel.getActiveContent())) {
				mapModel.addSubIdea = addSubIdea;
				mapModel.dropNode = dropNode;
				mapModel.paste = paste;
			} else {
				mapModel.addSubIdea = mapModelAddSubIdea;
				mapModel.dropNode = mapModelDropNode;
				mapModel.paste = mapModelPaste;
			}
		},
		getContext = function (content) {
			const active = isMappingActive(content),
				modelLoaded = !!mapModel.getIdea(),
				layout = mapModel.getCurrentLayout(),
				node = modelLoaded && active && layout && layout.nodes[mapModel.getSelectedNodeId()],
				context = {
					active: active
				};
			if (active) {
				if (labelGeneratorSet) {
					context.labelsShown = true;
				}
				if (node) {
					context.canAddParentReason = node.level !== 1;
					context.nodeGroupType = node.attr && node.attr.group;
				}
			}
			return context;
		},
		dispatchContext = function () {
			const content = collaborationModel.getActiveContent(),
				context = getContext(content);
			if (context) {
				self.dispatchEvent('argumentMappingContext', context);
			}
		},
		labelGeneratorName = 'SequenceByLevel',
		setNodeLabels = function (on) {
			if (on && isMappingActive(collaborationModel.getActiveContent())) {
				labelGeneratorSet = true;
				mapModel.setLabelGenerator(hierarchicalNumbers, labelGeneratorName);
			} else if (labelGeneratorSet) {
				if (labelGeneratorSet) {
					mapModel.setLabelGenerator(false, labelGeneratorName);
				}
				labelGeneratorSet = false;
			}
			dispatchContext();
		},
		getParentGroupNodeForLayout = (layout, nodeId) => {
			const node = layout && layout.nodes && layout.nodes[nodeId || mapModel.getSelectedNodeId()],
				isGroup = node && node.attr && node.attr.group;
			if (isGroup) {
				return node;
			}
			if (node && node.parentId) {
				return getParentGroupNodeForLayout(layout, node.parentId);
			}
			return false;
		},
		getParentGroupNode = (nodeId) => {
			const content = collaborationModel.getActiveContent(),
				active = isMappingActive(content),
				layout = active && mapModel.getCurrentLayout();
			if (layout) {
				return getParentGroupNodeForLayout(layout, nodeId);
			}
			return false;
		},
		updateGroupStrength = (delta) => {
			if (!delta) {
				return;
			}
			const node = getParentGroupNode(),
				currentWidth = node && (parseInt(node && node.attr && node.attr.parentConnector && node.attr.parentConnector.width) || 3),
				newWidth = currentWidth && Math.max(currentWidth + delta, 1);
			if (newWidth && newWidth !== currentWidth) {
				return mapModel.getIdea().mergeAttrProperty(node.id, 'parentConnector', 'width', newWidth);
			}
		};

	self.start = function () {
		const idea = collaborationModel.getActiveContent();
		oldTheme = idea.attr && idea.attr.theme;
		mapThemeModel.setTheme('argMappingSimple');
	};
	self.stop = function () {
		mapThemeModel.setTheme(oldTheme || 'default');
	};
	self.addOpposingGroup = function () {
		mapModel.addGroupSubidea('menu', {group: 'opposing'});
	};
	self.addSupportingGroup = function () {
		mapModel.addGroupSubidea('menu', {group: 'supporting'});
	};

	self.addStickyNote = ()  => addStickyNote('menu', false, '');

	self.makeGroupStronger = () => updateGroupStrength(2);
	self.makeGroupWeaker = () => updateGroupStrength(-2);
	self.addParentGroup = function () {
		mapModel.insertIntermediateGroup('menu', {group: 'supporting'});
	};
	self.toggleNodeLabels = function () {
		setNodeLabels(!labelGeneratorSet);
	};
	self.toggleImplicitClaim = function () {
		if (isNodeIdClaim(mapModel.getSelectedNodeId())) {
			mapEditorModel.toggleNodeStyleName('attr_implicit_claim');
		}
	};

	self.editGroupLineLabel = () => {
		const parentGroup = getParentGroupNode(),
			layout = parentGroup && mapModel.getCurrentLayout(),
			connectors = layout && layout.connectors,
			connector = connectors && connectors[parentGroup.id];
		if (!connector) {
			return;
		}
		mapEditorModel.editLineLabel(connector);
	};
	self.toggleGroupType = function () {
		const content = collaborationModel.getActiveContent(),
			active = isMappingActive(content),
			node = active && mapModel.getCurrentLayout().nodes[mapModel.getSelectedNodeId()],
			group = node && node.attr && node.attr.group,
			newGroup = group && (group === 'opposing' ? 'supporting' : 'opposing');

		if (newGroup) {
			content.updateAttr(mapModel.getSelectedNodeId(), 'group', newGroup);
		}
	};
	self.toggleStickyNote = () => {
		const idea = collaborationModel.getActiveContent().findSubIdeaById(mapModel.getSelectedNodeId());
		if (isGroup(idea)) {
			return false;
		}
		mapEditorModel.toggleNodeStyleName('sticky_note');
	};
	collaborationModel.addListener(function (content) {
		const active = isMappingActive(content);
		if (active !== wasActive) {
			mapModelOverridesWhenActive();
			setNodeLabels(true);
			wasActive = active;
		};
		dispatchContext();
	});
	mapModel.addEventListener('nodeSelectionChanged', function () {
		dispatchContext();
	});
	mapModel.addEventListener('labelGeneratorChange', function (setter, isSet) {
		if (setter !== labelGeneratorName) {
			labelGeneratorSet = false;
			dispatchContext();
		} else if (!isSet) {
			labelGeneratorSet = false;
			dispatchContext();
		} else if (!labelGeneratorSet) {
			labelGeneratorSet = true;
			dispatchContext();
		}
	});
};
